export const sendNotificationEmails = async (userDetails, planDetails, shouldFailSilently = true) => {
  let timeoutId;
  
  try {
    const controller = new AbortController();
    timeoutId = setTimeout(() => controller.abort(), 3000);

    // Use environment variable if set, otherwise determine API URL based on hostname.
    const apiBaseUrl = process.env.REACT_APP_API_URL || (
      window.location.hostname === 'localhost'
        ? 'http://localhost:3000'
        : 'https://fxbullsheet.com'
    );
    console.log('Using API URL:', `${apiBaseUrl}/api/send-email`);

    const response = await fetch(`${apiBaseUrl}/api/send-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Origin': window.location.origin
      },
      body: JSON.stringify({
        adminEmail: {
          to: 'support@fxbullsheet.com',
          userInfo: userDetails
        },
        userEmail: {
          to: userDetails.email,
          fullName: userDetails.fullName,
          planInfo: planDetails
        }
      }),
      signal: controller.signal
    });

    if (timeoutId) clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Email API response:', data);
    return data;

  } catch (error) {
    console.error('Email error:', error.message, error.stack);
    if (shouldFailSilently) return { success: false, error: error.message };
    throw error;
  } finally {
    if (timeoutId) clearTimeout(timeoutId);
  }
};